// extracted by mini-css-extract-plugin
export var details = "_gh-0";
export var inspectorPopover = "_gh-1";